import { CheckIcon } from "@heroicons/react/20/solid";

const statusOrder = [
  "created",
  "info_received",
  "in_transit",
  "out_for_delivery",
  "delivered",
];

const formatStatus = (status) =>
  status
    .split("_")
    .map((word) => word[0].toUpperCase() + word.slice(1))
    .join(" ");

export function ShipmentStatusStepper({ currentStatus }) {
  const currentIndex = statusOrder.indexOf(currentStatus);

  return (
    <nav
      aria-label="Shipment Progress"
      className="flex flex-col items-center w-full"
    >
      <ol
        className="relative flex justify-between w-full max-w-3xl px-4"
      >
        {/* Line behind the steps */}
        <div className="absolute top-1/4 left-0 w-full transform translate-y-1/4 z-0">
          <div className="flex justify-between w-full">
            {statusOrder.map((_, idx) => {
              const isComplete = idx <= currentIndex // ← key fix here
              return (
                <div
                  key={idx}
                  className={`h-0.5 flex-1 ${isComplete ? "bg-blue" : "bg-gray-200"}`}
                />
              );
            })}
          </div>
        </div>

        {statusOrder.map((status, stepIdx) => {
          const isCurrent = stepIdx === currentIndex;
          const isComplete = stepIdx < currentIndex;

          let circle = null;

          if (isCurrent) {
            circle = (
              <div className="flex h-7 w-7 items-center justify-center rounded-full bg-blue z-10">
                <CheckIcon className="h-5 w-5 text-white" />
              </div>
            );
          } else if (isComplete) {
            circle = <div className="h-5 w-5 rounded-full bg-blue z-10" />;
          } else {
            circle = (
              <div className="group h-4 w-4 rounded-full border-2 border-gray-300 bg-white z-10">
                <span className="block h-2.5 w-2.5 m-auto mt-0.5 rounded-full bg-transparent " />
              </div>
            );
          }

          return (
            <li
              key={status}
              className="flex flex-col items-center flex-1 relative"
            >
              <div
                className="mb-2 flex items-center justify-center"
                style={{ height: "32px" }}
              >
                {circle}
              </div>
              <div className="text-xs text-gray-500 text-center w-24">
                {formatStatus(status)}
              </div>
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
